import { DOMAIN } from "../../../../var_env."
import { RequestResponsePattern } from "../../../../types/Request"
import { postApi } from "../../../../utils/requestApi"
import { setRequestSaveData, setRequestSaveError, setRequestSaveLoading } from "../Reducers/LinksTutoriaisReducer"

export default async function saveLista(dispatch: Function, data: any) {
    try {
        dispatch(setRequestSaveLoading())
        const response: RequestResponsePattern<any> = await postApi({
            endpoint: `${DOMAIN}/LinksTutoriais/lista/save`,
            data,
        })
        if (response && !response.flagErro) {
            dispatch(setRequestSaveData(response))
        } else throw new Error(response?.listaMensagens?.[0] ?? 'Erro na requisição')
    } catch (error: any) {
        dispatch(setRequestSaveError())
    }
}
